export default function templateAnalytics(
  initialState = {
    templates: [],
    search: '',
    activeSort: '',
    sortOrder: '',
    totalCount: 0,
    page: 1
  },
  action
) {
  switch (action.type) {
    case 'SET_RESTAURANT_ADMIN_TEMPLATE_ANALYTICS_TEMPLATES':
      return {
        ...initialState,
        templates: action.payload,
      };

    case 'SET_RESTAURANT_ADMIN_TEMPLATE_ANALYTICS_SEARCH':
      return {
        ...initialState,
        search: action.payload,
      };

    case 'SET_RESTAURANT_ADMIN_TEMPLATE_ANALYTICS_ACTIVE_SORT':
      return {
        ...initialState,
        activeSort: action.payload,
      };

    case 'SET_RESTAURANT_ADMIN_TEMPLATE_ANALYTICS_SORT_ORDER':
      return {
        ...initialState,
        sortOrder: action.payload,
      };

    case 'SET_RESTAURANT_ADMIN_TEMPLATE_ANALYTICS_TOTAL_COUNT':
      return {
        ...initialState,
        totalCount: action.payload,
      };

    case 'SET_RESTAURANT_ADMIN_TEMPLATE_ANALYTICS_PAGE':
      return {
        ...initialState,
        page: action.payload,
      };

    case 'RESTAURANT_ADMIN_TEMPLATE_ANALYTICS_RESET':
      return {
        ...initialState,
        templates: [],
        search: '',
        activeSort: '',
        sortOrder: '',
        totalCount: 0,
        page: 1
      };

    default:
      return initialState;
  }
}
